export default "__VITE_ASSET__Ct85CuLU__"